export const SET_EDITOR_UTILITIES = 'SET_EDITOR_UTILITIES';
export const SET_EDITOR_FOCUSED = 'SET_EDITOR_FOCUSED';